import request from '@/utils/request'

//Login
export function networksaleshistory(page) {
  return request({ url: 'vnetworksaleshistory', method: 'post', data: {'page': page} })
} 
